<template>
    <view-card headline="가상계좌정보">
        <v-row v-if="value._virtualAccount" justify="center">
            <v-col cols="auto">
                은행명: <b>{{ bankName }}</b>
            </v-col>
            <v-col cols="auto">
                계좌번호: <b>{{ accountNumber }}</b>
            </v-col>
            <v-col cols="auto">
                예금주: <b>{{ accountHolder }}</b>
            </v-col>
        </v-row>
        <v-row v-else justify="center">
            <v-col cols="auto">부여된 가상계좌가 없습니다.</v-col>
        </v-row>
    </view-card>
</template>
<script>
import ViewCard from "../dumb/view-card.vue";

export default {
    components: { ViewCard },
    props: {
        value: {
            _virtualAccount: String,
            virtualAccount: Object,
        },
    },
    computed: {
        bankName() {
            switch (this.value?.virtualAccount?.bankNumber) {
                case "020":
                    return "우리은행";
                default:
                    return this.value?.virtualAccount?.bankNumber || "-";
            }
        },
        accountNumber() {
            return this.value?.virtualAccount?.accountNumber || "-";
        },
        accountHolder() {
            return "새집처럼";
        },
    },
};
</script>
